import React, { useState, useEffect, forwardRef } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { getIcons } from '_helpers';
import { Chip } from '@mui/material';

/**
 * Composant personnalisé: Autocomplete multiple
 */
export const MultiSelectAutocomplete = forwardRef(({
    name,
    label,
    options,
    noOptionsText = 'Aucune correspondance',
    onInputChange,
    onClear,
    disablePortal = true,
    endAdornmentIconSrc = 'clearOutlinedGrey',
    endAdornmentIconAlt = 'icon clear',
    isSubmitting = false,
    sxOverrides = {},
    value,
    onChange,
    disabled = false
}, ref) => {
    const [selectedOptions, setSelectedOptions] = useState(value);

    useEffect(() => {
        setSelectedOptions(value);
    }, [value]);

    /**
     * Gestion des événements de modification
     * @param {*} event 
     * @param {*} newInputValue 
     * @param {*} reason 
     * @returns 
     */
    const handleInputChange = (event, newInputValue, reason) => {
        if (reason === 'reset') {
            onInputChange(newInputValue);
            return;
        }
    };
    const handleClear = () => {
        setSelectedOptions([]);
        onClear();
    };
    const handleChange = (event, newValue) => {
        setSelectedOptions(newValue);
        onChange(newValue);
        onInputChange(newValue);
    };

    return (
            <Autocomplete
                disabled={disabled}
                multiple
                noOptionsText={noOptionsText}
                onInputChange={() => handleInputChange()}
                value={selectedOptions}
                onChange={handleChange}
                disablePortal={disablePortal}
                options={options}
                ref={ref}
                disableCloseOnSelect
                autoHighlight 
                clearOnEscape
                getOptionLabel={(option) => option?.label?.toString() ?? option?.toString() ?? ""}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                            <Chip
                                key={index}
                                label={option}
                                {...tagProps}
                                style={{
                                    backgroundColor: '#1454FE',  
                                    color: 'white',  
                                    marginRight: 5, 
                                }}
                            />
                        );
                    })}
                sx={{
                    ...sxOverrides
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        className={'form-control'}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <InputAdornment position="end">
                                    {selectedOptions.length > 0 && (
                                    <button
                                        onClick={handleClear}
                                        type="button"
                                        disabled={isSubmitting}
                                        className=""
                                    >
                                        <img
                                            src={getIcons(endAdornmentIconSrc)}
                                            alt={endAdornmentIconAlt}
                                            className="btn-custom-icon"
                                        />
                                    </button>)}
                                </InputAdornment>
                            ),
                            style: {
                                paddingRight: '8px', 
                            },
                        }}
                    />
                )}
                renderOption={(props, option, { selected }) => {
                    const { key, ...rest } = props; 
                    return (
                        <li key={key} {...rest} >
                            {option}
                        </li>
                    );
                }}
            />
    );
});